.layout {
  align-items: flex-start;
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: clamp(280px, 32%, 412px) minmax(0, 1fr);
  padding-top: var(--pgm-sys-spacing-6);
}

.layoutSingle {
  grid-template-columns: minmax(0, 1fr);
}

.visuallyHidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.listPane {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  min-width: 0;
}

.listActions {
  display: flex;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  list-style: none;
  margin: 0;
  padding: 0;
}

.periodCard {
  background-color: var(--pgm-sys-color-surface-container-low);
  border: 1px solid transparent;
  border-radius: 16px;
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  outline: none;
  overflow: hidden;
  padding: var(--pgm-sys-spacing-4);
  position: relative;
  text-decoration: none;
}

.periodCard::before {
  background: var(--pgm-sys-color-on-surface);
  content: "";
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.15s ease;
}

.periodCard:hover::before {
  opacity: 0.08;
}

.periodCard:active::before {
  opacity: 0.1;
}

.periodCard:hover,
.periodCard:focus {
  color: var(--pgm-sys-color-on-surface);
  text-decoration: none;
}

.periodCard:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.periodCardSelected,
.periodCardSelected:hover,
.periodCardSelected:focus {
  background-color: var(--pgm-sys-color-secondary-container);
  border-color: var(--pgm-sys-color-outline);
  color: var(--pgm-sys-color-on-secondary-container);
}

.periodCardHeader {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
  justify-content: space-between;
}

.periodCardTitle {
  min-width: 0;
}

.periodCardMeta {
  color: var(--pgm-sys-color-on-surface-variant);
}

.periodCardSelected .periodCardMeta {
  color: var(--pgm-sys-color-on-secondary-container);
}

.tag {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex-shrink: 0;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  white-space: nowrap;
}

.tagDot {
  background-color: currentColor;
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.tagDraft {
  background-color: var(--pgm-sys-color-info-container);
  color: var(--pgm-sys-color-on-info-container);
}

.tagDraft .tagDot {
  background-color: var(--pgm-sys-color-info);
}

.tagPublished {
  background-color: var(--pgm-sys-color-success-container);
  color: var(--pgm-sys-color-on-success-container);
}

.tagPublished .tagDot {
  background-color: var(--pgm-sys-color-success);
}

.message {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.detailPane {
  background-color: var(--pgm-sys-color-surface);
  border-radius: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 64px - var(--pgm-sys-spacing-12));
  min-width: 0;
}

.emptyDetail {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  justify-content: center;
  min-height: inherit;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
  text-align: center;
}

.emptyIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 64px;
}

.emptyText {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  max-width: 560px;
}

.emptyActions {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding-top: var(--pgm-sys-spacing-4);
}

.detail {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.detailHeader {
  align-items: flex-start;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
}

.detailHeading {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.detailTitle {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.backLink {
  align-items: center;
  border-radius: 50%;
  color: var(--pgm-sys-color-on-surface-variant);
  display: inline-flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  outline: none;
  position: relative;
  width: 40px;
}

.backLink::before {
  background: var(--pgm-sys-color-on-surface-variant);
  border-radius: inherit;
  content: "";
  inset: 0;
  opacity: 0;
  position: absolute;
  transition: opacity 0.15s ease;
}

.backLink:hover::before {
  opacity: 0.08;
}

.backLink:hover,
.backLink:focus {
  color: var(--pgm-sys-color-on-surface-variant);
  text-decoration: none;
}

.backLink:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
}

.tabs {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  display: flex;
}

.tab {
  align-items: center;
  background: none;
  border: 0;
  color: var(--pgm-sys-color-on-surface-variant);
  cursor: pointer;
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  min-height: 48px;
  outline: none;
  padding: 0 var(--pgm-sys-spacing-4);
  position: relative;
}

.tab::before {
  background: var(--pgm-sys-color-on-surface);
  content: "";
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.15s ease;
}

.tab:hover::before {
  opacity: 0.08;
}

.tab:active::before {
  opacity: 0.1;
}

.tab:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

.tabLabel {
  align-items: center;
  align-self: stretch;
  display: flex;
  position: relative;
}

.tabActive {
  color: var(--pgm-sys-color-primary);
}

.tabActive .tabLabel::after {
  background: var(--pgm-sys-color-primary);
  border-radius: 3px 3px 0 0;
  bottom: 0;
  content: "";
  height: 3px;
  left: 0;
  position: absolute;
  right: 0;
}

.tabPanel {
  padding-top: var(--pgm-sys-spacing-2);
}

.attorneys {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  list-style: none;
  margin: 0;
  padding: 0;
}

.attorney {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 12px;
  container-type: inline-size;
  overflow: hidden;
}

.attorneyName {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
}

.valueRow {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
  display: grid;
  gap: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-4);
  grid-template-columns: 112px minmax(0, 1fr);
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
}

.valueRowTitle {
  color: var(--pgm-sys-color-on-surface-variant);
}

.values {
  display: grid;
  gap: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
}

@container (max-width: 719.98px) {
  .valueRow {
    grid-template-columns: minmax(0, 1fr);
  }
}

@container (max-width: 479.98px) {
  .values {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.value {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.valueLabel {
  color: var(--pgm-sys-color-on-surface-variant);
}

.valueAmount {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  white-space: nowrap;
}

.notes {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.note {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.noteLabel {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.noteText {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  min-height: 120px;
  overflow-wrap: anywhere;
  padding: var(--pgm-sys-spacing-4);
  white-space: pre-wrap;
}

.noteEmpty {
  color: var(--pgm-sys-color-on-surface-variant);
}

.notesActions {
  display: flex;
  justify-content: flex-end;
}

.actionError {
  color: var(--pgm-sys-color-error);
  margin: 0;
}

.dialogText {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.dialogText p {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.periodFields {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

.periodFields > * {
  flex: 1 1 200px;
}

.fileField {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.fileLabel {
  color: var(--pgm-sys-color-on-surface);
}

.dropzone {
  align-items: center;
  border: 1px dashed var(--pgm-sys-color-outline);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-surface);
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
  margin: 0;
  min-height: 56px;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
}

.dropzone:hover,
.dropzoneActive {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-color: var(--pgm-sys-color-primary);
}

input:focus-visible + .dropzone {
  outline: 2px solid var(--pgm-sys-color-primary);
  outline-offset: 2px;
}

.dropzoneError {
  border-color: var(--pgm-sys-color-error);
}

.dropzoneText {
  flex: 1;
  overflow-wrap: anywhere;
}

.dropzoneAction {
  color: var(--pgm-sys-color-primary);
}

.fileHint {
  color: var(--pgm-sys-color-on-surface-variant);
}

.fileErrors {
  color: var(--pgm-sys-color-error);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  margin: 0;
  padding-left: var(--pgm-sys-spacing-5);
}

.progress {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) 0;
  text-align: center;
}

.progressText {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.spinner {
  animation: spin 1s linear infinite;
  border: 6px solid var(--pgm-sys-color-surface-container-highest);
  border-radius: 50%;
  border-top-color: var(--pgm-sys-color-primary);
  height: 48px;
  width: 48px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.warning {
  align-items: center;
  background-color: var(--pgm-sys-color-warning-container);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-warning-container);
  display: flex;
  gap: var(--pgm-sys-spacing-3);
  margin: 0;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
}

.ignoredList {
  display: grid;
  gap: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}

.ignoredItem {
  align-items: center;
  column-gap: var(--pgm-sys-spacing-2);
  display: grid;
  grid-template-columns: auto 1fr;
}

.ignoredIcon {
  color: var(--pgm-sys-color-error);
  grid-row: span 2;
}

.ignoredReason {
  color: var(--pgm-sys-color-on-surface-variant);
}

@media (max-width: 1199.98px) {
  .detailPane {
    min-height: 0;
  }

  .emptyDetail {
    min-height: 0;
  }
}

@media (max-width: 839.98px) {
  .layout {
    padding-top: var(--pgm-sys-spacing-4);
  }
}

@media (max-width: 599.98px) {
  .detail {
    padding: var(--pgm-sys-spacing-4);
  }

  .detailHeader {
    flex-wrap: wrap;
  }
}
